module.exports = __webpack_public_path__ + "img/bgR8.164f4c3c.png";